import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { AppBar, Toolbar, Typography, Box, Grid2, Button, InputBase, IconButton, Menu, MenuItem, Container, Badge } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './header.css';
import { Category, Search } from "@mui/icons-material";
import { GET_CATEGORY_HIERARCHY, GET_PRODUCT_BY_ID, GET_PRODUCT_SUGGESTIONS, SEARCH_PRODUCTS_BY_CATEGORY, SEARCH_PRODUCTS_BY_NAME } from '../../redux/apis';
import { url } from 'inspector';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/authReducer';
import { getLoggedInUser } from '../../utilities/authUtils';
import { axiosPublicInstance } from '../../redux/axiosInstance';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";


type DropdownMenu = string | null;

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

type OptionType = {
  id: number;
  name: string;
  type: string;
};

const CustomInput = styled(InputBase)(({ theme }) => ({
  // padding: theme.spacing(1),
  // border: '1px solid #ced4da',
  // borderRadius: 4,
  // backgroundColor: theme.palette.background.paper,
}));

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [openDropdowns, setOpenDropdowns] = useState<Record<string, DropdownMenu>>({});
  const [data, setData] = useState<any[]>([]);
  const [options, setOptions] = useState<OptionType[]>([]);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const dispatch = useDispatch();

  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const loginCustomerName = localStorage.getItem("firstName") ? localStorage.getItem("firstName") : isAuthenticated ? user.firstName : "";

  const cart = useSelector((state: any) => state.cart);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [cartCount, setCartCount] = useState<any>(0);

  const handleDropdownClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    navigate("/profilepage");
    handleClose();
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch(logout());
    handleClose();
    navigate("/");
  };

  useEffect(() => {
    getContents();
    let customerCarts = localStorage.getItem("customercarts");
    if (customerCarts) {
      let carts = JSON.parse(customerCarts);
      setCartCount(carts.length);
    }
  }, []);

  const getContents = async () => {
    try {
      // const response = await axiosPublicInstance.get(GET_CATEGORY_HIERARCHY);
      // Add this at the top, before your component
      const headerData = [
        {
          "categoryId": 0,
          "categoryName": "All Categories",
          "categoryImageUrl": null,
          "subCategories": [
            {
              "categoryId": 1,
              "categoryName": "CCTV Cameras",
              "categoryImageUrl": require("../../../assets/Home/Cctv.png"),
              "subCategories": [
                {
                  "categoryId": 11,
                  "categoryName": "Bullet Cameras",
                  "categoryImageUrl": require("../../../assets/first.png"),
                  "subCategories": []
                },
                {
                  "categoryId": 12,
                  "categoryName": "Dome Cameras",
                  "categoryImageUrl": require("../../../assets/second.png"),
                  "subCategories": []
                }
              ]
            },
            {
              "categoryId": 2,
              "categoryName": "Security Accessories",
              "categoryImageUrl": require("../../../assets/third.png"),
              "subCategories": []
            }
          ]
        }
      ];

      setData(headerData)
    } catch (error) {
      console.error(error);
    }
  };

  const handleMouseEnter = (level: number, menuName: DropdownMenu) => {
    setOpenDropdowns((prev) => ({ ...prev, [level]: menuName }));
  };

  const handleMouseLeave = (level: number) => {
    setOpenDropdowns((prev) => ({ ...prev, [level]: null }));
  };

  const handleNavigation = () => {
    navigate("/mycart");
  };

  const handleTrackOrder = () => {
    navigate("/tracknow");
  };

  const handleInstallation = () => {
    navigate("/installationservice");
  };

  const handleClick = async (event: any, category: any) => {
    event.stopPropagation();
    try {
      if (category && category.categoryId) {
        navigate("/productlist", { state: { categoryId: category.categoryId, searchText: "" } })
      }
    } catch (error) {
      console.error(error);
    }
    handleMouseLeave(0);
  };

  const renderMenu = (menu: any, level = 0) => {
    return (
      <ul className={level === 0 ? 'change' : level === 1 ? `dropdown-Category-1 level-${level}` : `dropdown-category-all level-${level}`} key={level}>
        {menu.map((item: any) => (
          <li
            style={level === 0 ? { backgroundColor: "#f5f5f5" } : {}}
            key={item.categoryId}
            onMouseEnter={() => handleMouseEnter(level, item.categoryName)}
            onMouseLeave={() => handleMouseLeave(level)}
            onClick={(event) => handleClick(event, item)}
          >
            {level !== 0 ? <img style={{ marginRight: '8px' }} src={item && item.categoryImageUrl ? { url: item.categoryImageUrl } : require('../../../assets/camer.png')} /> : null}
            {item.categoryName}
            {openDropdowns[level] === item.categoryName && item.subCategories.length > 0 &&
              renderMenu(item.subCategories, level + 1)}
          </li>
        ))}
      </ul>
    );
  };

  const getSearchSuggestions = async (val: any) => {
    try {
      const response: any = await axiosPublicInstance.get(`${GET_PRODUCT_SUGGESTIONS}${val}`);
      if (!response) {
        console.log(`Error: ${response.status} - ${response.statusText}`);
        setOptions([]);
        return;
      }
      if (Array.isArray(response.data)) {
        setOptions(response.data);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.error("Error:", error);
      setOptions([]);
    }
  };

  const handleChange = async (event: any, newValue: OptionType | null) => {
    setValue(newValue);
    if (newValue && newValue.type === "Category") {
      await axiosPublicInstance.get(`${SEARCH_PRODUCTS_BY_CATEGORY}${newValue.id}`);
      navigate("/productlist", { state: { categoryId: newValue.id, searchText: "" } })
    }
    else if (newValue && newValue.type === "Product") {
      navigate("/productdetail", { state: newValue.id })
    }
  };

  const searchProducts = async () => {
    try {
      navigate("/productlist", { state: { categoryId: "", searchText: searchText } })
    } catch (error) {
      console.error("Errror:", error);
      setOptions([]);
    }
  };

  return (
    <AppBar position="fixed" sx={{ top: 0, left: 0, right: 0, zIndex: 30, mb: 4, backgroundColor: "white" }}>

      <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', p: 1 }}>
        {/* <Toolbar> */}
        <Grid2 container spacing={2} direction="row" sx={{ minHeight: '70px', alignItems: "center", justifyContent: 'center' }}>
          <Grid2 size={{ sm: 12, lg: 7, md: 7 }}>
            <Grid2 container spacing={2} direction="row" sx={{ alignItems: "center", justifyContent: 'center' }}>
              <Grid2 size={3}>
                <Box
                  onClick={() => navigate("/")}
                  component="img"
                  style={{
                    width: '120%',
                    height: '60%',
                    // height: 'auto',
                    cursor: 'pointer',
                  }}
                  src={require("../../../assets/Home/niruval.png")}
                  marginLeft={-4}
                />
              </Grid2>

              <Grid2 size={9}>
                <Box sx={styles.searchContainer}>
                  {/* <Button sx={styles.searchButton}>
                    <Search sx={styles.searchIcon} />
                  </Button> */}
                  <Box
                    component="img"
                    // style={{
                    //   width: WIDTH < 400 ? "auto" : (WIDTH * 4) / 100,
                    //   height: (HEIGHT * 2) / 100,
                    //   marginRight: (WIDTH * 0.5) / 100
                    // }}
                    sx={{
                      p: 1
                    }}
                    src={require("../../../assets/Home/CategoryMenuIcon.png")}
                  />
                  <div className="menu">{renderMenu(data)}</div>
                  <Autocomplete
                    value={value}
                    sx={styles.input}
                    onChange={handleChange}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) =>
                      setInputValue(newInputValue)
                    }
                    options={options ?? []}
                    getOptionLabel={(option) => (option ? option.name : "")} // Use the "name" property for display
                    renderInput={(params) => (
                      <InputBase
                        fullWidth
                        ref={params.InputProps.ref}
                        inputProps={params.inputProps}
                        placeholder="Search for Products & Categories"
                        sx={styles.input}
                        onChange={(event) => {
                          setSearchText(event.target.value);
                          getSearchSuggestions(event.target.value);
                        }}
                      />
                    )}
                    PaperComponent={({ children }: any) => (
                      <Paper elevation={3} sx={{ marginTop: 1 }}>
                        {children}
                      </Paper>
                    )}
                  />

                  <Button sx={styles.searchButton} onClick={searchProducts}>
                    <Search sx={styles.searchIcon} />
                  </Button>
                </Box>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={{ sm: 12, lg: 5, md: 5, xs: 12 }}>
            <Grid2 container spacing={1} direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
              <Grid2 size={{ lg: 4, md: 4, sm: 3.5, xs: 4 }}>
                <Grid2 container direction={'row'} sx={{
                  justifyContent: 'center', alignItems: 'center', cursor: 'pointer', px: 1, '&:hover': {
                    backgroundColor: '#f0f0f0',
                    cursor: 'pointer',
                    borderRadius: 4,
                  }
                }}>
                  {/* <Grid2 size={1}>
                    <Box component="img" src={require("../../../assets/Home/person.png")} />
                  </Grid2> */}
                  <Grid2 size={12}>
                    <Typography sx={{ color: "black", mt: 1, ml: 1, mb: 0.9 }} variant="subtitle1" onClick={handleInstallation}>
                      Installation Service
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 size={{ lg: 3, md: 3, sm: 2.5, xs: 3 }}>
                <Grid2 container direction={"row"} sx={{
                  justifyContent: 'end', alignItems: 'center', marginLeft: "10px", cursor: 'pointer', px: 1, '&:hover': {
                    backgroundColor: '#f0f0f0',
                    cursor: 'pointer',
                    borderRadius: 4,
                  }
                }}>
                  <Grid2 size={1}>
                    <Box component="img" sx={{ mt: 0.5, mb: 0.5 }} src={require("../../../assets/Home/Frame.png")} />
                  </Grid2>
                  <Grid2 size={11}>
                    <Typography sx={{ color: "black", mt: 1, ml: 1.5, mb: 0.5 }} variant="subtitle1" onClick={handleTrackOrder}>
                      Track Order
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 size={{ lg: 4, md: 4, sm: 4, xs: 4 }}>
                <Grid2 container direction={"row"} sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: "10px" }}>
                  {loginCustomerName ? (
                    <Box sx={{ display: "flex", alignItems: "center", cursor: 'pointer' }} onClick={handleDropdownClick}>
                      <AccountCircleIcon sx={{ color: "black", fontSize: 25, marginTop: 0.5 }} />
                      <Typography variant="body1" sx={{ color: "black", ml: 1, mt: 1 }}>
                        <strong>{loginCustomerName}</strong>
                      </Typography>
                      <IconButton onClick={handleDropdownClick} sx={{ mt: 1, p: 0 }}>
                        <ArrowDropDownIcon />
                      </IconButton>
                      <Menu
                        id="menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <MenuItem onClick={handleProfile}>Profile</MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                      </Menu>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center", mr: 6, cursor: 'pointer' }}>
                      <AccountCircleIcon sx={{ color: "black", fontSize: 25, mt: 1, mb: 0.5 }} />
                      <Typography variant="body1" sx={{ color: "black", mt: 1, ml: 1, mb: 0.5 }}>
                        <a href="/login" style={{ color: "black", textDecoration: "none" }}>
                          <strong>Login</strong>
                        </a>
                      </Typography>
                    </Box>
                  )}
                </Grid2>
              </Grid2>
              <Grid2 size={{ lg: 1, md: 1, sm: 2, xs: 1 }} sx={{ cursor: 'pointer', ml: 'auto', textAlign: 'center' }} onClick={handleNavigation}>
                {/* <Grid2 container spacing={0} direction="row" sx={{ justifyContent: 'center', alignItems: 'center' }} onClick={handleNavigation}>
                  <Grid2 size={4}> */}
                <Badge
                  badgeContent={cartCount}
                  color="error"
                  invisible={cartCount === 0}
                  sx={{
                    "& .MuiBadge-dot": {
                      backgroundColor: '#c72a22',
                    },
                  }}
                >
                  <ShoppingCartIcon sx={{ fontSize: 25, color: 'black', mt: 1 }} />
                </Badge>
                {/* </Grid2>
                </Grid2> */}
              </Grid2>
            </Grid2>

          </Grid2>
        </Grid2>
        {/* </Toolbar> */}
      </Container>
    </AppBar >
  );
};

const styles = {
  searchContainer: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    border: "1px solid #ddd",
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "#f5f5f5",
  },
  categoriesButton: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    borderRight: "1px solid #ddd",
    cursor: "pointer",
    backgroundColor: "#ffffff",
    color: "#000000",
    textTransform: "none", // Ensures the text isn't all caps
    '&:hover': {
      backgroundColor: '#f0f0f0', // Adds a subtle hover effect
    }
  },
  icon: {
    marginRight: "8px",
  },
  arrow: {
    marginLeft: "4px",
    fontSize: "12px",
  },
  input: {
    flex: 1,
    paddingLeft: "10px",
    border: "none",
    outline: "none",
    fontSize: "14px",
    backgroundColor: "transparent",
  },
  searchButton: {
    padding: "10px",
    border: "none",
    backgroundColor: '#c72a22',
    //"#ff5722",
    color: "#ffffff",
    cursor: "pointer",
    // height: "6vh",
    borderRadius: "0 4px 4px 0",
    '&:hover': {
      backgroundColor: '#c72a22', // Adds a hover effect for the button
    }
  },
  searchIcon: {
    fontSize: "18px",
  },
};

export default Header;